<template>
  <div class="basis-video-player" @click="toggoleVideo">
    <video-player
      ref="videoPlayer"
      :options="options"
      :playsinline="true"
      @play="onPlayerPlay($event)"
      @pause="onPlayerPause($event)"
      @ended="onPlayerEnded($event)"
      @loadeddata="onPlayerLoadeddata($event)"
      @waiting="onPlayerWaiting($event)"
      @playing="onPlayerPlaying($event)"
      @timeupdate="onPlayerTimeupdate($event)"
      @canplay="onPlayerCanplay($event)"
      @canplaythrough="onPlayerCanplaythrough($event)"
      @ready="playerReadied"
      @statechanged="playerStateChanged($event)"
    />
    <van-icon
      v-if="item.video"
      name="play-circle-o"
      :class="['play-icon', {hide: mode}]"
    />
  </div>
</template>

<script>
import 'video.js/dist/video-js.css'
import VideoPlayer from 'vue-video-player/src/player'

export default {
  name: 'BasisVideoPlayer',
  components: { VideoPlayer },
  model: {
    prop: 'value',
    event: 'readied'
  },
  props: {
    value: {
      type: undefined,
      required: true
    },
    item: {
      type: Object,
      default: () => {},
      required: true
    },
    coverOptions: {
      type: Object,
      default: () => {},
      required: false
    }
  },
  data: () => ({
    mode: false,
    videoPlayer: undefined,
    definedOptions: {
      // videojs options
      responsive: true,
      autoplay: false,
      preload: 'none',
      muted: false,
      playsinline: true,
      'x5-video-player-type': 'h5',
      'x5-video-player-fullscreen': true,
      language: 'zh-CN',
      playbackRates: [0.7, 1.0, 1.5, 2.0],
      bigPlayButton: false,
      notSupportedMessage: '此视频暂无法播放，请稍后再试',
      controlBar: {
        fullscreenToggle: false
      }
    }
  }),
  computed: {
    options () {
      const { cover, video } = this.item
      return {
        poster: cover,
        sources: [
          {
            type: 'video/mp4',
            src: video
          }
        ],
        ...this.definedOptions,
        ...this.coverOptions
      }
    }
  },
  watch: {
    '$route.params.id': {
      handler (newId, oldId) {
        if (newId !== oldId) {
          this.mode = false
        }
      }
    }
  },
  methods: {
    toggoleVideo () {
      this.mode = !this.mode
      switch (this.mode) {
        case true:
          this.videoPlayer.player.play()
          break
        case false:
          this.videoPlayer.player.pause()
          break
      }
    },
    onPlayerPlay (player) {
      // console.log('player play!', player)
      this.mode = true
      this.$emit('playerPlay', player)
    },
    onPlayerPause (player) {
      // console.log('player pause!', player)
      this.mode = false
      this.$emit('playerPause', player)
    },
    onPlayerEnded (player) {
      // console.log('player ended!', player)
      this.$emit('playerEnded', player)
    },
    onPlayerLoadeddata (player) {
      // console.log('player Loadeddata!', player)
      this.$emit('playerLoadeddata', player)
    },
    onPlayerWaiting (player) {
      // console.log('player Waiting!', player)
      this.$emit('playerWaiting', player)
    },
    onPlayerPlaying (player) {
      // console.log('player Playing!', player)
      this.$emit('playerPlaying', player)
    },
    onPlayerTimeupdate (player) {
      // console.log('player Timeupdate!', player.currentTime())
      this.$emit('playerTimeupdate', player)
    },
    onPlayerCanplay (player) {
      // console.log('player Canplay!', player)
      this.$emit('playerCanplay', player)
    },
    onPlayerCanplaythrough (player) {
      // console.log('player Canplaythrough!', player)
      this.$emit('playerCanplaythrough', player)
    },
    // or listen state event
    playerStateChanged (playerCurrentState) {
      // console.log('player current update state', playerCurrentState)
      this.$emit('playerStateChanged', playerCurrentState)
    },
    // player is ready
    playerReadied (player) {
      // seek to 10s
      this.videoPlayer = this.$refs.videoPlayer
      this.$emit('readied', this.videoPlayer)
      this.$emit('playerReadied', player)
    }
  }
}
</script>

<style scoped lang="scss">
.basis-video-player {
  position: relative;
  .play-icon {
    @include ct;
    font-size: 60px;
    color: #f5f5f5;
    opacity: 0.6;
    transition: all .2s linear;
    &.hide {
      opacity: 0;
      font-size: 100px;
    }
  }
}
</style>
